import React, { useState,useEffect } from 'react'
import AdminLayout from '../AdminLayout'
import ContentHeader from '../layout/ContentHeader'
import { HOT_KEYS } from '../../../data/constant';
import TableLayout from '../layout/TableLayout';

export default function HotKeys() {

     const tableHeaders = ['#', 'key', 'View'];

     const keys = ["key", "label"];

     const [tblData,setTableData] = useState([]);

     const setData = () => {
          const data = HOT_KEYS;
          const ctrlSExists = data.some(item => item.key === "ctrl+s");
          if (!ctrlSExists) {
               data.push({ key: "ctrl+s", label: "Save Invoice / Order / Bill / Quote" });
               setTableData(data);
          }
     }    
     
     useEffect(() => {
          setData();
     },[])

     return (
          <AdminLayout>
               <div className="content-wrapper">
                    <ContentHeader title="short_keys" />
                    <div className="col-md-10 m-auto">
                         <div className="card">
                              <div className="card-body">
                                   <TableLayout
                                        headers={tableHeaders}
                                        keys={keys}
                                        tableData={tblData}
                                   />
                              </div>
                         </div>
                    </div>
               </div>
          </AdminLayout>
     )
}
